import { render, staticRenderFns } from "./content-social-icons.vue?vue&type=template&id=0c81434e&scoped=true"
import script from "./content-social-icons.vue?vue&type=script&lang=js"
export * from "./content-social-icons.vue?vue&type=script&lang=js"
import style0 from "./content-social-icons.vue?vue&type=style&index=0&id=0c81434e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81434e",
  null
  
)

export default component.exports